import PixelNoise from './class/PixelNoise'
import * as THREE from 'three';

export default function canvas() {
  const perticle = new PixelNoise(
    document.getElementById("glImage"),
    document.getElementById("glCanvas")
  )
}
